import * as React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';

const RoleEdit = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/permission/${id}`)
		.then(({ data = {} }) => {
			const { result = {  } } = data;
			setFields(result?.data ?? []);
		})
		.catch(err => {
			console.log(err);
		})
	}, [ id ]);

	const handleSubmit = (fields) => {
		axios.post(`/api/permission/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/permission');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/permission')
	}

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Өгөгдөлд хандах эрх засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default RoleEdit;